import type {
  CostProjectionDataType,
  CostProjectionValidation,
  MSADataType,
  MSAValidation,
  AmendedReviewScreeningType,
  AmendedReviewValidation,
  ServiceDateOfInjury,
  DocumentManagementDataType,
} from "types/DataTypes";

import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

type ServiceType =
  | MSADataType
  | CostProjectionDataType
  | AmendedReviewScreeningType
  | DocumentManagementDataType;
type ValidationType =
  | MSAValidation
  | CostProjectionValidation
  | AmendedReviewValidation;

type InitialState = {
  currentService: ServiceType | null;
  currentServiceDoi: ServiceDateOfInjury | null;
  validation: ValidationType | null;
  selectedIds: (string | number)[];
  showAddCoverageModal: boolean;
  hasCoverage: boolean;
  coverageComplete: boolean;
  noCoverage: boolean;
  selectedServiceDoi: number | null;
  selectedFileDoi: number | null;
};

const futureMedicalSlice = createSlice({
  name: "futureMedical",
  initialState: {
    currentService: null,
    currentServiceDoi: null,
    validation: null,
    selectedIds: [],
    showAddCoverageModal: false,
    hasCoverage: false,
    noCoverage: false,
    coverageComplete: false,
    selectedServiceDoi: null,
    selectedFileDoi: null,
  } as InitialState,
  reducers: {
    setSelectedServiceDoi(state, action: PayloadAction<number | null>) {
      state.selectedServiceDoi = action.payload;
    },
    setSelectedFileDoi(state, action: PayloadAction<number | null>) {
      state.selectedFileDoi = action.payload;
    },
    setCurrentServiceDoi(
      state,
      action: PayloadAction<ServiceDateOfInjury | null>,
    ) {
      state.currentServiceDoi = action.payload;
    },
    setService(state, action: PayloadAction<ServiceType>) {
      state.currentService = action.payload;
    },
    setValidation(state, action: PayloadAction<ValidationType>) {
      state.validation = action.payload;
    },
    setSelectedIds(state, action: { payload: (string | number)[] }) {
      state.selectedIds = action.payload;
    },
    setShowAddCoverageModal(state, action: PayloadAction<boolean>) {
      state.showAddCoverageModal = action.payload;
    },
    setNoCoverage(state, action: PayloadAction<boolean>) {
      state.noCoverage = action.payload;
    },
    setCoverageState(
      state,
      action: PayloadAction<{
        hasCoverage: boolean;
        coverageComplete: boolean;
        noCoverage: boolean;
      }>,
    ) {
      state.hasCoverage = action.payload.hasCoverage;
      state.coverageComplete = action.payload.coverageComplete;
      state.noCoverage = action.payload.noCoverage;
    },
  },
});

const { reducer } = futureMedicalSlice;

export const {
  setSelectedServiceDoi,
  setSelectedFileDoi,
  setCurrentServiceDoi,
  setService,
  setValidation,
  setSelectedIds,
  setShowAddCoverageModal,
  setCoverageState,
  setNoCoverage,
} = futureMedicalSlice.actions;

export default reducer;
